import { instance } from "apis/interceptor";
import * as Sentry from "@sentry/react";

type ResponseType<T> = {
    success: boolean;
    statusCode?: number;
    message?: string;
    data?: T;
};

export type TScheduledVisitPurpose = {
    id?: string;
    displayOrder?: number;
    image?: string;
    content?: string;
};

//INFO: (new) 사전 방문 목적 조회
export const getScheduledVisitPurpose = async (): Promise<ResponseType<TScheduledVisitPurpose[]>> => {
    try {
        const res = await instance.get("/visitors/setting/scheduled-visit/purpose");
        return { success: true, data: res.data };
    } catch (error) {
        Sentry.captureException(error);
        return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
    }
};

//INFO: (new) 사전 방문 목적 저장
export const updateScheduledVisitPurpose = async (list: TScheduledVisitPurpose[]): Promise<ResponseType<boolean>> => {
    try {
        const res = await instance.patch("/visitors/setting/scheduled-visit/purpose", {
            visitPurposes: list,
        });
        return { success: res.data.result };
    } catch (error) {
        Sentry.captureException(error, { extra: { list: list } });
        return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
    }
};
